import { useQuery } from '@tanstack/react-query';
import { PermissionsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function usePermissionsControllerListPermissionsQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['permissionsControllerListPermissions', accessControlScope, args],
        queryFn: async () => {
            const api = new PermissionsApi(accessControlConfig);
            return api.permissionsControllerListPermissions(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=usePermissionsControllerListPermissionsQuery.js.map